import { AnimatePresence, motion } from 'framer-motion';
import { ReactNode } from 'react';
import { toast } from 'react-toastify';

interface BaseToastProps {
  children: ReactNode;
  toastKey?: string;
  role?: string;
  onClose?: () => void;
}

export const BaseToast = ({
  children,
  toastKey = 'toast',
  role = 'notification',
  onClose = () => toast.dismiss()
}: BaseToastProps) => {
  return (
    <AnimatePresence initial={false} mode="wait" onExitComplete={() => null}>
      <motion.div
        key={toastKey}
        layout
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 100 }}
        exit={{
          opacity: 0,
          y: -100,
          scale: 0.9,
          transition: {
            duration: 0.2,
            ease: 'easeOut'
          }
        }}
        role={role}
        drag="y"
        dragConstraints={{ top: 0, bottom: 0 }}
        dragElastic={0.2}
        dragTransition={{ bounceStiffness: 100, bounceDamping: 10 }}
        onDragEnd={(_, info) => {
          if (info.velocity.y < -20 || info.offset.y < -50) {
            onClose();
          }
        }}
        transition={{
          duration: 0.3,
          type: 'tween',
          ease: 'easeInOut'
        }}
        style={{ width: '100%' }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
